import sessions from "./build/main.js"; import "./build/main.css"; module.exports = sessions;